import AuthorYear from "../../components/author-year/authorYear";
import { MultiselectOption } from "../../components/multiselect/types";
import { Option } from "../../components/Dropdown/Dropdown";

export const advancedSearchIndexes = [
  "all",
  "term.creatorcontributor",
  "term.subject",
  // "term.genreandform",
  // "term.mainlanguage",
  // "datefirstedition",
  "term.creator",
  "term.title",
  // "term.source",
  "dk5",
  // "term.specificmaterialtype",
  // "term.childrenoradults",
  "term.publisher",
  "term.isbn",
  "localid",
  "term.notes",
] as const;

export const advancedSearchIndexTranslations = {
  all: "advancedSearchAllIndexesText",
  "term.creatorcontributor": "advancedSearchCreatorText",
  "term.subject": "advancedSearchSubjectText",
  // "term.genreandform": "advancedSearchGenreText",
  // "term.mainlanguage": "advancedSearchLanguageText",
  // datefirstedition: "advancedSearchDateText",
  "term.creator": "advancedSearchMainCreatorText",
  "term.title": "advancedSearchMainTitleText",
  // "term.source": "advancedSearchSourceText",
  // "term.mood": "advancedSearchMoodText",
  dk5: "advancedSearchDecimalDk5Text",
  // "term.generalmaterialtype": "advancedSearchTypeText",
  "term.specificmaterialtype": "advancedSearchTypeText",
  // "term.specificmaterialtype": "advancedSearchSpecificTypeText",
  // "term.childrenoradults": "advancedSearchAudienceText",
  "term.publisher": "advancedSearchPublisherText",
  "term.isbn": "advancedSearchIdentifierText",
  "localid": "advancedSearchLocalidText",
  "term.notes": "advancedSearchNotesText"
} as const;

export type AdvancedSearchIndex = typeof advancedSearchIndexes[number];

export type AdvancedSearchClause = {
  value: "AND" | "OR" | "NOT";
  translation: string;
};

export const advancedSearchClauses: AdvancedSearchClause[] = [
  { value: "AND", translation: "clauseAndText" },
  { value: "OR", translation: "clauseOrText" },
  { value: "NOT", translation: "clauseNotText" }
];

export type AdvancedSearchRowData = {
  term: string;
  searchIndex: AdvancedSearchIndex | "";
  clause: AdvancedSearchClause;
  id: number;
};

export type AdvancedSearchRowUpdateRowAspect =
  | "term"
  | "searchIndex"
  | "clause";

export type AdvancedSearchFilterData = {
  materialTypes: MultiselectOption[];
  fiction: MultiselectOption[];
  accessibility: MultiselectOption[];
  ageGroups: MultiselectOption[];
  primaryTarget: MultiselectOption[];
  source: MultiselectOption[];
  childrenoradults: MultiselectOption[];
  branch: MultiselectOption[];
  sublocation: MultiselectOption[];
  language: MultiselectOption[];
  publicationYear: MultiselectOption[];
  mood: MultiselectOption[];
  genreandform: MultiselectOption[];
};

export type AdvancedSearchSortData = {
  currentSorting: MultiselectOption[];
};

export type AdvancedSearchTextInputFilterData = {
  publicationYear: String;
  lix: String;
  let: String;
  ages: String;
  ageGroups: String;
};

export type AdvancedSearchQuery = {
  rows: AdvancedSearchRowData[];
  filters: AdvancedSearchFilterData;
  sort: AdvancedSearchSortData;
  textInputFilters: AdvancedSearchTextInputFilterData;
};

export const initialAdvancedSearchQuery: AdvancedSearchQuery = {
  /* This controls how many rows of search fields are initially present when user loads page */
  rows: [
    { term: "", searchIndex: "all", clause: advancedSearchClauses[0], id: 0 },
    // { term: "", searchIndex: "all", clause: advancedSearchClauses[0], id: 1 }
  ],
  filters: {
    materialTypes: [{ item: "multiselectAllOptionText", value: "all" }],
    fiction: [{ item: "multiselectAllOptionText", value: "all" }],
    accessibility: [{ item: "multiselectAllOptionText", value: "all" }],
    ageGroups: [{ item: "multiselectAllOptionText", value: "all" }],
    primaryTarget: [{ item: "multiselectAllOptionText", value: "all" }],
    source: [{ item: "multiselectAllOptionText", value: "all" }],
    childrenoradults: [{ item: "multiselectAllOptionText", value: "all" }],
    branch: [{ item: "multiselectAllOptionText", value: "all" }],
    sublocation: [{ item: "multiselectAllOptionText", value: "all" }],
    language: [{ item: "multiselectAllOptionText", value: "all" }],
    publicationYear: [{ item: "multiselectAllOptionText", value: "all" }],
    mood: [{ item: "multiselectAllOptionText", value: "all" }],
    genreandform: [{ item: "multiselectAllOptionText", value: "all" }],
  },
  sort: {
    currentSorting: [{ item: "Bedste match", value: "Bedste match" }],
  },
  textInputFilters: {
    publicationYear: "",
    lix: "",
    let: "",
    ages: "",
    ageGroups: "",
    // publicationYear: "publication year"
  }
};

// These are mainly general material types mixed with some specific ones
// the logic for handling this is found in helpers.tsx
export const advancedSearchMaterialTypes: MultiselectOption[] = [
  { item: "advancedSearchFilterBookText", value: "bøger" },
  { item: "advancedSearchFilterEbookText", value: "e-bøger" },
  { item: "advancedSearchFilterAudioBookText", value: "lydbøger" },
  { item: "advancedSearchFilterArticleText", value: "artikler" },
  { item: "advancedSearchFilterMovieText", value: "film" },
  { item: "advancedSearchFilterMusicText", value: "musik" },
  { item: "advancedSearchFilterMusicCdText", value: "musik (cd)" },
  { item: "advancedSearchFilterMusicGrammofonpladeText", value: "musik (grammofonplade)" },
  { item: "advancedSearchFilterBoardGamesText", value: "brætspil" },
  { item: "advancedSearchFilterNewspaperJournalsText", value: "aviser og tidsskrifter" },
  { item: "advancedSearchFilterComicsText", value: "tegneserier" },
  { item: "advancedSearchFilterComputerGamesText", value: "computerspil" },
  { item: "advancedSearchFilterImageMaterialsText", value: "billedmaterialer" },
  { item: "advancedSearchFilterTvSeriesText", value: "tv-serier" },
  { item: "advancedSearchFilterPodcastsText", value: "podcasts" },
  { item: "advancedSearchFilterSheetMusicText", value: "noder" },
  { item: "advancedSearchFilterOtherText", value: "øvrige" },
];

export const advancedSearchAccessibility: MultiselectOption[] = [
  { item: "advancedSearchFilterPhysicalText", value: "fysisk" },
  { item: "advancedSearchFilterOnlineText", value: "online" }
];

export const advancedSearchPrimaryTarget: MultiselectOption[] = [
  { item: "advancedSearchFilterFoerskoleNiveauText", value: "førskoleniveau" },
  { item: "advancedSearchFilterFolkeskoleNiveauText", value: "folkeskoleniveau" },
  { item: "advancedSearchFilterGymnasieNiveauText", value: "gymnasieniveau" },
  { item: "advancedSearchFilterFagligtNiveauText", value: "fagligt niveau" },
  { item: "advancedSearchFilterForskningsNiveauText", value: "forskningsniveau" },
  { item: "advancedSearchFilterAlmentText", value: "alment niveau" },
  // { item: "advancedSearchFilterAlmentText", value: "Udenfor kategori eller vurdering fravalgt" },
];

export const advancedSearchChildrenoradults: MultiselectOption[] = [
  { item: "advancedSearchFilterAdultsText", value: "Voksne" },
  { item: "advancedSearchFilterChildrenText", value: "Børn" }
];

export const advancedSearchSublocationFilter: MultiselectOption[] = [
  { item: "advancedSearchFilterSublocation72Text", value: "72" },
  { item: "advancedSearchFilterSublocationAfghanskText", value: "Afghansk" },
  { item: "advancedSearchFilterSublocationAlbanskText", value: "Albansk" },
  { item: "advancedSearchFilterSublocationAmbientText", value: "Ambient" },
  { item: "advancedSearchFilterSublocationAntologiText", value: "Antologi" },
  { item: "advancedSearchFilterSublocationArabiskText", value: "Arabisk" },
  { item: "advancedSearchFilterSublocationArabiskDepot1Text", value: "Arabisk depot 1" },
  { item: "advancedSearchFilterSublocationArabiskDepot2Text", value: "Arabisk depot 2" },
  { item: "advancedSearchFilterSublocationAssensText", value: "Assens" },
  { item: "advancedSearchFilterSublocationAvText", value: "Av" },
  { item: "advancedSearchFilterSublocationAviserText", value: "Aviser" },
  { item: "advancedSearchFilterSublocationBalletmusikAntologierText", value: "Balletmusik. antologier" },
  { item: "advancedSearchFilterSublocationBalletmusikText", value: "Balletmusik" },
  { item: "advancedSearchFilterSublocationBibliotekarbordText", value: "Bibliotekarbord" },
  { item: "advancedSearchFilterSublocationRockAntologierText", value: "Rock. Antologier" },
  { item: "advancedSearchFilterSublocationRockText", value: "Rock" },
  { item: "advancedSearchFilterSublocationBilledbogEngelskText", value: "Billedbog engelsk" },
  { item: "advancedSearchFilterSublocationBilledbogText", value: "Billedbog" },
  { item: "advancedSearchFilterSublocationBluesAntologierText", value: "Blues. antologier" },
  { item: "advancedSearchFilterSublocationBluesText", value: "Blues" },
  { item: "advancedSearchFilterSublocationBluRayText", value: "Blu-Ray" },
  { item: "advancedSearchFilterSublocationBogCdText", value: "Bog + CD" },
  { item: "advancedSearchFilterSublocationBogenseText", value: "Bogense" },
  { item: "advancedSearchFilterSublocationBogOgSprogText", value: "Bog & sprog" },
  { item: "advancedSearchFilterSublocationBogstaverOgTalText", value: "Bogstaver og tal" },
  { item: "advancedSearchFilterSublocationBosniskText", value: "Bosnisk" },
  { item: "advancedSearchFilterSublocationBosniskDep2Text", value: "Bosnisk dep 2" },
  { item: "advancedSearchFilterSublocationBosniskDep3Text", value: "Bosnisk dep 3" },
  { item: "advancedSearchFilterSublocationBrobyText", value: "Broby" },
  { item: "advancedSearchFilterSublocationBraetspilText", value: "Brætspil" },
  { item: "advancedSearchFilterSublocationBoernText", value: "Børn" },
  { item: "advancedSearchFilterSublocationBoernekomedierText", value: "Børnekomedier" },
  { item: "advancedSearchFilterSublocationBoernematerialerText", value: "Børnematerialer" },
  { item: "advancedSearchFilterSublocationBoernemusikSangText", value: "Børnemusik/sang" },
  { item: "advancedSearchFilterSublocationCdromText", value: "CD-Rom" },
  { item: "advancedSearchFilterSublocationCdromSmaaboernText", value: "CD-Rom småbørn" },
  { item: "advancedSearchFilterSublocationCountryWesternText", value: "Country & western" },
  { item: "advancedSearchFilterSublocationCountryWesternAntologierText", value: "Country & western. antologier" },
  { item: "advancedSearchFilterSublocationDancePopText", value: "Dance/pop" },
  { item: "advancedSearchFilterSublocationDancePopAntologierText", value: "Dance/pop. antologier" },
  { item: "advancedSearchFilterSublocationDanmarkText", value: "Danmark" },
  { item: "advancedSearchFilterSublocationDanskText", value: "Dansk" },
  { item: "advancedSearchFilterSublocationDanskuddannelserText", value: "Danskuddannelser" },
  { item: "advancedSearchFilterSublocationDariText", value: "Dari" },
  { item: "advancedSearchFilterSublocationAfghanskPersiskText", value: "Afghansk persisk" },
  { item: "advancedSearchFilterSublocationDanskUnderholdningText", value: "Dansk underholdning" },
  { item: "advancedSearchFilterSublocationDepotVollsmoseText", value: "Depot i Vollsmose" },
  { item: "advancedSearchFilterSublocationDigteText", value: "Digte" },
  { item: "advancedSearchFilterSublocationDisneyText", value: "Disney" },
  { item: "advancedSearchFilterSublocationDanskJazzText", value: "Dansk jazz" },
  { item: "advancedSearchFilterSublocationDanskJazzAntologierText", value: "Dansk jazz. antologier" },
  { item: "advancedSearchFilterSublocationDanskRockText", value: "Dansk rock" },
  { item: "advancedSearchFilterSublocationDanskRockAntologierText", value: "Dansk rock. antologier" },
  { item: "advancedSearchFilterSublocationDvdText", value: "DVD" },
  { item: "advancedSearchFilterSublocationDvdromText", value: "DVD-Rom" },
  { item: "advancedSearchFilterSublocationDvdTvSerierText", value: "DVD Tv-serier" },
  { item: "advancedSearchFilterSublocationDvdVideoText", value: "DVD Video" },
  { item: "advancedSearchFilterSublocationEgebjergText", value: "Egebjerg" },
  { item: "advancedSearchFilterSublocationEjbyText", value: "Ejby" },
  { item: "advancedSearchFilterSublocationElectronicaAntologierText", value: "Electronica. antologier" },
  { item: "advancedSearchFilterSublocationElectronicaText", value: "Electronica" },
  { item: "advancedSearchFilterSublocationEndnuIkkeUndervejsText", value: "Endnu ikke undervejs" },
  { item: "advancedSearchFilterSublocationEngelskText", value: "Engelsk" },
  { item: "advancedSearchFilterSublocationEngelskLetText", value: "Engelsk. Let" },
  { item: "advancedSearchFilterSublocationEsperantoText", value: "Esperanto" },
  { item: "advancedSearchFilterSublocationEtInstrumentText", value: "Et instrument" },
  { item: "advancedSearchFilterSublocationEtInstrumentAntologierText", value: "Et instrument. antologier" },
  { item: "advancedSearchFilterSublocationEuInfoText", value: "EUInfo" },
  { item: "advancedSearchFilterSublocationEventyrText", value: "Eventyr" },
  { item: "advancedSearchFilterSublocationFantasticFictionText", value: "Fantastic Fiction" },
  { item: "advancedSearchFilterSublocationFantasyText", value: "Fantasy" },
  { item: "advancedSearchFilterSublocationFilmmusikText", value: "Filmmusik" },
  { item: "advancedSearchFilterSublocationFindeLedeText", value: "Finde/lede" },
  { item: "advancedSearchFilterSublocationFinskText", value: "Finsk" },
  { item: "advancedSearchFilterSublocationFjernlaanText", value: "Fjernlån" },
  { item: "advancedSearchFilterSublocationFolkemusikText", value: "Folkemusik" },
  { item: "advancedSearchFilterSublocationForaeldrehyldeText", value: "Forældrehylde" },
  { item: "advancedSearchFilterSublocationFolkOgWorldText", value: "Folk & world" },
  { item: "advancedSearchFilterSublocationFolkOgWorldAfghanistanText", value: "Folk & world. Afghanistan" },
  { item: "advancedSearchFilterSublocationFolkOgWorldAfrikaText", value: "Folk & world. Afrika" },
  { item: "advancedSearchFilterSublocationFolkOgWorldArgentinaText", value: "Folk & world. Argentina" },
  { item: "advancedSearchFilterSublocationFolkOgWorldAsienText", value: "Folk & world. Asien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldAustralienText", value: "Folk & world. Australien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldBrasilienText", value: "Folk & world. Brasilien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldBulgarienText", value: "Folk & world. Bulgarien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldCanadaText", value: "Folk & world. Canada" },
  { item: "advancedSearchFilterSublocationFolkOgWorldCongoText", value: "Folk & world. Congo" },
  { item: "advancedSearchFilterSublocationFolkOgWorldCubaText", value: "Folk & world. Cuba" },
  { item: "advancedSearchFilterSublocationFolkOgWorldDanmarkText", value: "Folk & world. Danmark" },
  { item: "advancedSearchFilterSublocationFolkOgWorldEgyptenText", value: "Folk & world. Egypten" },
  { item: "advancedSearchFilterSublocationFolkOgWorldEuropaText", value: "Folk & world. Europa" },
  { item: "advancedSearchFilterSublocationFolkOgWorldFinlandText", value: "Folk & world. Finland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldFrankrigText", value: "Folk & world. Frankrig" },
  { item: "advancedSearchFilterSublocationFolkOgWorldGhanaText", value: "Folk & world. Ghana" },
  { item: "advancedSearchFilterSublocationFolkOgWorldGraekenlandText", value: "Folk & world. Grækenland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldGroenlandText", value: "Folk & world. Grønland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldGuineaText", value: "Folk & world. Guinea" },
  { item: "advancedSearchFilterSublocationFolkOgWorldIndienText", value: "Folk & world. Indien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldIrakText", value: "Folk & world. Irak" },
  { item: "advancedSearchFilterSublocationFolkOgWorldIranText", value: "Folk & world. Iran" },
  { item: "advancedSearchFilterSublocationFolkOgWorldIrlandText", value: "Folk & world. Irland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldIsraelText", value: "Folk & world. Israel" },
  { item: "advancedSearchFilterSublocationFolkOgWorldItalienText", value: "Folk & world. Italien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldJapanText", value: "Folk & world. Japan" },
  { item: "advancedSearchFilterSublocationFolkOgWorldKinaText", value: "Folk & world. Kina" },
  { item: "advancedSearchFilterSublocationFolkOgWorldLatinamerikaText", value: "Folk & world. Latinamerika" },
  { item: "advancedSearchFilterSublocationFolkOgWorldLibanonText", value: "Folk & world. Libanon" },
  { item: "advancedSearchFilterSublocationFolkOgWorldMaliText", value: "Folk & world. Mali" },
  { item: "advancedSearchFilterSublocationFolkOgWorldMellemoestenText", value: "Folk & world. Mellemøsten" },
  { item: "advancedSearchFilterSublocationFolkOgWorldMexicoText", value: "Folk & world. Mexico" },
  { item: "advancedSearchFilterSublocationFolkOgWorldNigeriaText", value: "Folk & world. Nigeria" },
  { item: "advancedSearchFilterSublocationFolkOgWorldNordamerikaText", value: "Folk & world. Nordamerika" },
  { item: "advancedSearchFilterSublocationFolkOgWorldNorgeText", value: "Folk & world. Norge" },
  { item: "advancedSearchFilterSublocationFolkOgWorldOceanienText", value: "Folk & world. Oceanien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldPakistanText", value: "Folk & world. Pakistan" },
  { item: "advancedSearchFilterSublocationFolkOgWorldPolenText", value: "Folk & world. Polen" },
  { item: "advancedSearchFilterSublocationFolkOgWorldPortugalText", value: "Folk & world. Portugal" },
  { item: "advancedSearchFilterSublocationFolkOgWorldRumaenienText", value: "Folk & world. Rumænien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldRuslandText", value: "Folk & world. Rusland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSenegalText", value: "Folk & world. Senegal" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSkotlandText", value: "Folk & world. Skotland" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSomaliaText", value: "Folk & world. Somalia" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSpanienText", value: "Folk & world. Spanien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldStorbritannienText", value: "Folk & world. Storbritannien" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSverigeText", value: "Folk & world. Sverige" },
  { item: "advancedSearchFilterSublocationFolkOgWorldSydafrikaText", value: "Folk & world. Sydafrika" },
  { item: "advancedSearchFilterSublocationFolkOgWorldTibetText", value: "Folk & world. Tibet" },
  { item: "advancedSearchFilterSublocationFolkOgWorldTyrkietText", value: "Folk & world. Tyrkiet" },
  { item: "advancedSearchFilterSublocationFolkOgWorldUsaText", value: "Folk & world. U.S.A." },
  { item: "advancedSearchFilterSublocationFolkOgWorldVestbalkanText", value: "Folk & world. Vestbalkan" },
  { item: "advancedSearchFilterSublocationFolkOgWorldVietnamText", value: "Folk & world. Vietnam" },
  { item: "advancedSearchFilterSublocationFranskText", value: "Fransk" },
  { item: "advancedSearchFilterSublocationFynText", value: "Fyn" },
  { item: "advancedSearchFilterSublocationFaeroeskText", value: "Færøsk" },
  { item: "advancedSearchFilterSublocationFoelelserText", value: "Følelser" },
  { item: "advancedSearchFilterSublocationFaaborgText", value: "Faaborg" },
  { item: "advancedSearchFilterSublocationGenstandText", value: "Genstand" },
  { item: "advancedSearchFilterSublocationGeografiText", value: "Geografi" },
  { item: "advancedSearchFilterSublocationGivBogenVidereText", value: "Giv bogen videre" },
  { item: "advancedSearchFilterSublocationGlamsbjergText", value: "Glamsbjerg" },
  { item: "advancedSearchFilterSublocationGospelText", value: "Gospel" },
  { item: "advancedSearchFilterSublocationGrafikText", value: "Grafik" },
  { item: "advancedSearchFilterSublocationGraphicNovelText", value: "Graphic novel" },
  { item: "advancedSearchFilterSublocationGraeskText", value: "Græsk" },
  { item: "advancedSearchFilterSublocationGroenlandskText", value: "Grønlandsk" },
  { item: "advancedSearchFilterSublocationGudmeText", value: "Gudme" },
  { item: "advancedSearchFilterSublocationGuidetMeditationText", value: "Guidet meditation" },
  { item: "advancedSearchFilterSublocationGuitarText", value: "Guitar" },
  { item: "advancedSearchFilterSublocationGuitarAntologierText", value: "Guitar. antologier" },
  { item: "advancedSearchFilterSublocationHcAndersenText", value: "H.C. Andersen" },
  { item: "advancedSearchFilterSublocationHeavyText", value: "Heavy" },
  { item: "advancedSearchFilterSublocationHeavyAntologierText", value: "Heavy. antologier" },
  { item: "advancedSearchFilterSublocationHesteText", value: "Heste" },
  { item: "advancedSearchFilterSublocationHindiText", value: "Hindi" },
  { item: "advancedSearchFilterSublocationHipHopAntologierText", value: "Hip hop, antologier" },
  { item: "advancedSearchFilterSublocationHistorieText", value: "Historie" },
  { item: "advancedSearchFilterSublocationHistorierBoernText", value: "Historier. Børn" },
  { item: "advancedSearchFilterSublocationHiphopText", value: "Hip hop" },
  { item: "advancedSearchFilterSublocationHollandskText", value: "Hollandsk" },
  { item: "advancedSearchFilterSublocationHoejtlaesningText", value: "Højtlæsning" },
  { item: "advancedSearchFilterSublocationHaandbogText", value: "Håndbog" },
  { item: "advancedSearchFilterSublocationHaarbyText", value: "Haarby" },
  { item: "advancedSearchFilterSublocationIndiskMusikText", value: "Indisk musik" },
  { item: "advancedSearchFilterSublocationIslandskText", value: "Islandsk" },
  { item: "advancedSearchFilterSublocationItaliText", value: "Itali" },
  { item: "advancedSearchFilterSublocationItalienskText", value: "Italiensk" },
  { item: "advancedSearchFilterSublocationJapanskText", value: "Japansk" },
  { item: "advancedSearchFilterSublocationJazzText", value: "Jazz" },
  { item: "advancedSearchFilterSublocationJazzAntologierText", value: "Jazz. antologier" },
  { item: "advancedSearchFilterSublocationJulText", value: "Jul" },
  { item: "advancedSearchFilterSublocationJulemusikText", value: "Julemusik" },
  { item: "advancedSearchFilterSublocationJumbobogText", value: "Jumbobog" },
  { item: "advancedSearchFilterSublocationKammermusikText", value: "Kammermusik" },
  { item: "advancedSearchFilterSublocationKammermusikAntologierText", value: "Kammermusik. antologier" },
  { item: "advancedSearchFilterSublocationKaraokeText", value: "Karaoke" },
  { item: "advancedSearchFilterSublocationKertemindeText", value: "Kerteminde" },
  { item: "advancedSearchFilterSublocationKinesiskText", value: "Kinesisk" },
  { item: "advancedSearchFilterSublocationKitText", value: "Kit" },
  { item: "advancedSearchFilterSublocationKlaverAntologierText", value: "Klaver. antologier" },
  { item: "advancedSearchFilterSublocationKlassesaetText", value: "Klassesæt" },
  { item: "advancedSearchFilterSublocationKlassikereText", value: "Klassikere" },
  { item: "advancedSearchFilterSublocationKlaverText", value: "Klaver" },
  { item: "advancedSearchFilterSublocationKlezmerText", value: "Klezmer" },
  { item: "advancedSearchFilterSublocationKontorText", value: "Kontor" },
  { item: "advancedSearchFilterSublocationKopiMappeHyldeText", value: "Kopi mappe/hylde" },
  { item: "advancedSearchFilterSublocationKorText", value: "Kor" },
  { item: "advancedSearchFilterSublocationKortText", value: "Kort" },
  { item: "advancedSearchFilterSublocationKrimiOgSpaendingText", value: "Krimi & Spænding" },
  { item: "advancedSearchFilterSublocationKristendomText", value: "Kristendom" },
  { item: "advancedSearchFilterSublocationKroatiskText", value: "Kroatisk" },
  { item: "advancedSearchFilterSublocationKroatiskDep2Text", value: "Kroatisk dep 2" },
  { item: "advancedSearchFilterSublocationKroatiskDep3Text", value: "Kroatisk dep 3" },
  { item: "advancedSearchFilterSublocationKurdiskText", value: "Kurdisk" },
  { item: "advancedSearchFilterSublocationKurdiskDep2Text", value: "Kurdisk dep 2" },
  { item: "advancedSearchFilterSublocationKurdiskDep3Text", value: "Kurdisk dep 3" },
  { item: "advancedSearchFilterSublocationLangelandText", value: "Langeland" },
  { item: "advancedSearchFilterSublocationLangeskovText", value: "Langeskov" },
  { item: "advancedSearchFilterSublocationLetText", value: "Let" },
  { item: "advancedSearchFilterSublocationLet1Text", value: "Let 1" },
  { item: "advancedSearchFilterSublocationLet2Text", value: "Let 2" },
  { item: "advancedSearchFilterSublocationLet3Text", value: "Let 3" },
  { item: "advancedSearchFilterSublocationLetAmerikanskText", value: "Let amerikansk" },
  { item: "advancedSearchFilterSublocationLetEngelskText", value: "Let engelsk" },
  { item: "advancedSearchFilterSublocationLetFranskText", value: "Let fransk" },
  { item: "advancedSearchFilterSublocationLetItalienskText", value: "Let italiensk" },
  { item: "advancedSearchFilterSublocationLetRussiskText", value: "Let russisk" },
  { item: "advancedSearchFilterSublocationLetSomaliskText", value: "Let somalisk" },
  { item: "advancedSearchFilterSublocationLetSpanskText", value: "Let spansk" },
  { item: "advancedSearchFilterSublocationLetTyskText", value: "Let tysk" },
  { item: "advancedSearchFilterSublocationLetteFagboegerText", value: "Lette fagbøger" },
  { item: "advancedSearchFilterSublocationLillebaeltText", value: "Lillebælt" },
  { item: "advancedSearchFilterSublocationLitauiskText", value: "Litauisk" },
  { item: "advancedSearchFilterSublocationLydbogText", value: "Lydbog" },
  { item: "advancedSearchFilterSublocationLydbogMp3Text", value: "Lydbog. MP3" },
  { item: "advancedSearchFilterSublocationLydeffekterText", value: "Lydeffekter" },
  { item: "advancedSearchFilterSublocationLaererarbejdspladserText", value: "Lærerarbejdspladser" },
  { item: "advancedSearchFilterSublocationLaererboegerText", value: "Lærerbøger" },
  { item: "advancedSearchFilterSublocationLaeringscenterVollsmoseBibliotekText", value: "Læringscenter, Vollsmose Bibliotek" },
  { item: "advancedSearchFilterSublocationLaesestartText", value: "Læsestart" },
  { item: "advancedSearchFilterSublocationMadText", value: "Mad" },
  { item: "advancedSearchFilterSublocationMagasinText", value: "Magasin" },
  { item: "advancedSearchFilterSublocationMangaText", value: "Manga" },
  { item: "advancedSearchFilterSublocationMarstalText", value: "Marstal" },
  { item: "advancedSearchFilterSublocationMatematikText", value: "Matematik" },
  { item: "advancedSearchFilterSublocationMentalSundhedText", value: "Mental sundhed" },
  { item: "advancedSearchFilterSublocationMiddelalderRenaessanceText", value: "Middelalder/renæssance" },
  { item: "advancedSearchFilterSublocationMiddelalderRenaessanceAntologierText", value: "Middelalder/renæssance. antologier" },
  { item: "advancedSearchFilterSublocationMiddelfartText", value: "Middelfart" },
  { item: "advancedSearchFilterSublocationMunkeboText", value: "Munkebo" },
  { item: "advancedSearchFilterSublocationMusikinstrumentText", value: "Musikinstrument" },
  { item: "advancedSearchFilterSublocationNaturTeknikText", value: "Natur/Teknik" },
  { item: "advancedSearchFilterSublocationNewAgeText", value: "New Age" },
  { item: "advancedSearchFilterSublocationNintendoDsText", value: "Nintendo DS" },
  { item: "advancedSearchFilterSublocationNintendoSwitchText", value: "Nintendo Switch" },
  { item: "advancedSearchFilterSublocationNintendoWiiText", value: "Nintendo Wii" },
  { item: "advancedSearchFilterSublocationNordfynText", value: "Nordfyn" },
  { item: "advancedSearchFilterSublocationNorskText", value: "Norsk" },
  { item: "advancedSearchFilterSublocationNovellerText", value: "Noveller" },
  { item: "advancedSearchFilterSublocationNyborgText", value: "Nyborg" },
  { item: "advancedSearchFilterSublocationNoerreAabyText", value: "Nørre Aaby" },
  { item: "advancedSearchFilterSublocationOdenseText", value: "Odense" },
  { item: "advancedSearchFilterSublocationOrgelText", value: "Orgel" },
  { item: "advancedSearchFilterSublocationOrgelAntologierText", value: "Orgel. antologier" },
  { item: "advancedSearchFilterSublocationOperaerText", value: "Operaer" },
  { item: "advancedSearchFilterSublocationOperaerAntologierText", value: "Operaer. antologier" },
  { item: "advancedSearchFilterSublocationOperetterMusicalsText", value: "Operetter/musicals" },
  { item: "advancedSearchFilterSublocationOperetterMusicalsAntologierText", value: "Operetter/musicals. antologier" },
  { item: "advancedSearchFilterSublocationOrkestermusikText", value: "Orkestermusik" },
  { item: "advancedSearchFilterSublocationOrkestermusikAntologierText", value: "Orkestermusik. antologier" },
  { item: "advancedSearchFilterSublocationOtterupText", value: "Otterup" },
  { item: "advancedSearchFilterSublocationPashtoText", value: "Pashto" },
  { item: "advancedSearchFilterSublocationPegeboegerText", value: "Pegebøger" },
  { item: "advancedSearchFilterSublocationPersiskText", value: "Persisk" },
  { item: "advancedSearchFilterSublocationPersiskDep2Text", value: "Persisk dep 2" },
  { item: "advancedSearchFilterSublocationPlaystation2Text", value: "Playstation 2" },
  { item: "advancedSearchFilterSublocationPlaystation3Text", value: "Playstation 3" },
  { item: "advancedSearchFilterSublocationPlaystation4Text", value: "Playstation 4" },
  { item: "advancedSearchFilterSublocationPlaystation5Text", value: "Playstation 5" },
  { item: "advancedSearchFilterSublocationPolskText", value: "Polsk" },
  { item: "advancedSearchFilterSublocationPortugisiskText", value: "Portugisisk" },
  { item: "advancedSearchFilterSublocationPuslespilText", value: "Puslespil" },
  { item: "advancedSearchFilterSublocationPaaskeText", value: "Påske" },
  { item: "advancedSearchFilterSublocationRbUrbanText", value: "R&b/urban" },
  { item: "advancedSearchFilterSublocationRbUrbanAntologierText", value: "R&b/urban. antologier" },
  { item: "advancedSearchFilterSublocationReggaeText", value: "Reggae" },
  { item: "advancedSearchFilterSublocationReggaeAntologierText", value: "Reggae. antologier" },
  { item: "advancedSearchFilterSublocationRegnbuehyldeText", value: "Regnbuehylde" },
  { item: "advancedSearchFilterSublocationReminiscensText", value: "Reminiscens" },
  { item: "advancedSearchFilterSublocationReparationText", value: "Reparation" },
  { item: "advancedSearchFilterSublocationRimOgRemserText", value: "Rim og remser" },
  { item: "advancedSearchFilterSublocationRingeText", value: "Ringe" },
  { item: "advancedSearchFilterSublocationRudkoebingText", value: "Rudkøbing" },
  { item: "advancedSearchFilterSublocationRumaenskText", value: "Rumænsk" },
  { item: "advancedSearchFilterSublocationRussiskText", value: "Russisk" },
  { item: "advancedSearchFilterSublocationRussiskDep1Text", value: "Russisk dep 1" },
  { item: "advancedSearchFilterSublocationRussiskDep2Text", value: "Russisk dep 2" },
  { item: "advancedSearchFilterSublocationRyslingeText", value: "Ryslinge" },
  { item: "advancedSearchFilterSublocationRytmiskKorText", value: "Rytmisk kor" },
  { item: "advancedSearchFilterSublocationRytmiskOrkesterText", value: "Rytmisk orkester" },
  { item: "advancedSearchFilterSublocationSamfundsfagText", value: "Samfundsfag" },
  { item: "advancedSearchFilterSublocationScienceFictionText", value: "Science Fiction" },
  { item: "advancedSearchFilterSublocationSerbiskText", value: "Serbisk" },
  { item: "advancedSearchFilterSublocationSerbiskDep2Text", value: "Serbisk dep 2" },
  { item: "advancedSearchFilterSublocationSerbiskDep3Text", value: "Serbisk dep 3" },
  { item: "advancedSearchFilterSublocationSerboKroatiskText", value: "Serbo-kroatisk" },
  { item: "advancedSearchFilterSublocationSjoveBoegerText", value: "Sjove bøger" },
  { item: "advancedSearchFilterSublocationSkuespilText", value: "Skuespil" },
  { item: "advancedSearchFilterSublocationSolosangText", value: "Solosang" },
  { item: "advancedSearchFilterSublocationSolosangAntologierText", value: "Solosang. antologier" },
  { item: "advancedSearchFilterSublocationSomaliText", value: "Somali" },
  { item: "advancedSearchFilterSublocationSoulText", value: "Soul" },
  { item: "advancedSearchFilterSublocationSoulAntologierText", value: "Soul.antologier" },
  { item: "advancedSearchFilterSublocationSpanskText", value: "Spansk" },
  { item: "advancedSearchFilterSublocationSportText", value: "Sport" },
  { item: "advancedSearchFilterSublocationSprogOgLegText", value: "Sprog og leg" },
  { item: "advancedSearchFilterSublocationSprogkufferterText", value: "Sprogkufferter" },
  { item: "advancedSearchFilterSublocationStorSkriftText", value: "Stor skrift" },
  { item: "advancedSearchFilterSublocationStorebaeltText", value: "Storebælt" },
  { item: "advancedSearchFilterSublocationStortFormatText", value: "Stort format" },
  { item: "advancedSearchFilterSublocationStortStortFormatText", value: "Stort stort format" },
  { item: "advancedSearchFilterSublocationStudiesamlingText", value: "Studiesamling" },
  { item: "advancedSearchFilterSublocationStoettecenterText", value: "Støttecenter" },
  { item: "advancedSearchFilterSublocationSvendborgText", value: "Svendborg" },
  { item: "advancedSearchFilterSublocationSvenskText", value: "Svensk" },
  { item: "advancedSearchFilterSublocationDenSvaereSamtaleText", value: "Den svære samtale" },
  { item: "advancedSearchFilterSublocationSydlangelandText", value: "Sydlangeland" },
  { item: "advancedSearchFilterSublocationSoendersoeText", value: "Søndersø" },
  { item: "advancedSearchFilterSublocationSoeskendeText", value: "Søskende" },
  { item: "advancedSearchFilterSublocationTamilText", value: "Tamil" },
  { item: "advancedSearchFilterSublocationTaskebogText", value: "Taskebog" },
  { item: "advancedSearchFilterSublocationTegneserierText", value: "Tegneserier" },
  { item: "advancedSearchFilterSublocationTemaposerText", value: "Temaposer" },
  { item: "advancedSearchFilterSublocationTestpladerText", value: "Testplader" },
  { item: "advancedSearchFilterSublocationThaiText", value: "Thai" },
  { item: "advancedSearchFilterSublocationTidsskrifterText", value: "Tidsskrifter" },
  { item: "advancedSearchFilterSublocationTidsskrifterMagText", value: "TidsskrifterMag" },
  { item: "advancedSearchFilterSublocationTigrinjaIndvandrerdepotText", value: "Tigrinja, indvandrerdepot" },
  { item: "advancedSearchFilterSublocationTjekkiskText", value: "Tjekkisk" },
  { item: "advancedSearchFilterSublocationTommerupText", value: "Tommerup" },
  { item: "advancedSearchFilterSublocationTranekaerText", value: "Tranekær" },
  { item: "advancedSearchFilterSublocationTyrkiskText", value: "Tyrkisk" },
  { item: "advancedSearchFilterSublocationTyrkiskMusikText", value: "Tyrkisk musik" },
  { item: "advancedSearchFilterSublocationTyskText", value: "Tysk" },
  { item: "advancedSearchFilterSublocationUdstillingText", value: "Udstilling" },
  { item: "advancedSearchFilterSublocationUdstillingHb1salText", value: "Udstilling HB 1. sal" },
  { item: "advancedSearchFilterSublocationUdstillingHb2salText", value: "Udstilling HB 2. sal" },
  { item: "advancedSearchFilterSublocationUdstillingHbKaelderText", value: "Udstilling HB kælder" },
  { item: "advancedSearchFilterSublocationUdstillingHbStuenText", value: "Udstilling HB stuen" },
  { item: "advancedSearchFilterSublocationUkrainskText", value: "Ukrainsk" },
  { item: "advancedSearchFilterSublocationUllerslevText", value: "Ullerslev" },
  { item: "advancedSearchFilterSublocationUnderholdningText", value: "Underholdning" },
  { item: "advancedSearchFilterSublocationUrduText", value: "Urdu" },
  { item: "advancedSearchFilterSublocationVennerOgVeninderText", value: "Venner og veninder" },
  { item: "advancedSearchFilterSublocationVietnamesiskText", value: "Vietnamesisk" },
  { item: "advancedSearchFilterSublocationVirkelighedensVerdenText", value: "Virkelighedens verden" },
  { item: "advancedSearchFilterSublocationVissenbjergText", value: "Vissenbjerg" },
  { item: "advancedSearchFilterSublocationVokalmusikText", value: "Vokalmusik" },
  { item: "advancedSearchFilterSublocationVokalmusikAntologierText", value: "Vokalmusik. antologier" },
  { item: "advancedSearchFilterSublocationXboxText", value: "Xbox" },
  { item: "advancedSearchFilterSublocationXbox360Text", value: "Xbox 360" },
  { item: "advancedSearchFilterSublocationXboxOneSpilText", value: "Xbox One spil" },
  { item: "advancedSearchFilterSublocationXboxSeriesXText", value: "Xbox Series X" },
  { item: "advancedSearchFilterSublocationAeroeText", value: "Ærø" },
  { item: "advancedSearchFilterSublocationAeroeskoebingText", value: "Ærøskøbing" },
  { item: "advancedSearchFilterSublocationOerbaekText", value: "Ørbæk" },
  { item: "advancedSearchFilterSublocationAaitaText", value: "ÅITA" },
  { item: "advancedSearchFilterSublocationAarslevText", value: "Årslev" },
  { item: "advancedSearchFilterSublocationAarupText", value: "Aarup" },
];

export const advancedSearchBranchFilter: MultiselectOption[] = [
  { item: "advancedSearchFilterHovedbiblioteketText", value: "Hovedbiblioteket" },
  { item: "advancedSearchFilterBolbroText", value: "Bolbro Bibliotek" },
  { item: "advancedSearchFilterDalumText", value: "Dalum Bibliotek" },
  { item: "advancedSearchFilterHollufPileText", value: "Holluf Pile Bibliotek" },
  { item: "advancedSearchFilterHoejbyText", value: "Højby Bibliotek" },
  { item: "advancedSearchFilterKorupText", value: "Korup Bibliotek" },
  { item: "advancedSearchFilterLokalhistoriskText", value: "Lokalhistorisk Bibliotek" },
  { item: "advancedSearchFilterTarupText", value: "Tarup Bibliotek" },
  { item: "advancedSearchFilterVollsmoseText", value: "Vollsmose Bibliotek" },
];

// Sorting options are "singleselect", not multiselect
export const advancedSearchSort: Option[] = [
  { label: "Bedste match", value: "bestmatch;" },
  { label: "Nyeste først", value: "sort.latestpublicationdate;DESC" },
  { label: "Ældste først", value: "sort.latestpublicationdate;ASC" },
  { label: "Forfatter/ophav a-å", value: "sort.creator;ASC" },
  { label: "Forfatter/ophav å-a", value: "sort.creator;DESC" },
  { label: "Titel a-å", value: "sort.title;ASC" },
  { label: "Titel å-a", value: "sort.title;DESC" },
];

export const advancedSearchSource: MultiselectOption[] = [
  { item: "advancedSearchFilterAccessScienceText", value: "access science" },
  { item: "advancedSearchFilterArtikelbasensAnmeldelserText", value: "anmeldelser" },
  { item: "advancedSearchFilterArtikelbasensTidsskriftsartiklerText", value: "artikelbasens tidsskriftsartikler" },
  { item: "advancedSearchFilterArtikelbasensAvisartiklerText", value: "avisartikler" },
  // { item: "advancedSearchFilterArtikelbasensAvisartiklerMedInfomedialinkText", value: "Artikelbasens avisartikler med infomedia" },
  // { item: "advancedSearchFilterBibliotekernesPodcastsText", value: "bibliotekernes podcasts" },
  // { item: "advancedSearchFilterArtikelbasensTidsskriftsartiklerMedInfomedialinkText", value: "artikelbasens tidsskriftsartikler med infomedia-link" },
  { item: "advancedSearchFilterBiblioteketsPosterMedAktiveBeholdningerForFbsBibliotekerText", value: "bibliotekskatalog" },
  // { item: "advancedSearchFilterComicsPlusText", value: "comics plus" },
  { item: "advancedSearchFilterDanskernesHistorieOnlineText", value: "danskernes historie online" },
  { item: "advancedSearchFilterEbookCentralText", value: "ebook central" },
  { item: "advancedSearchFilterEbookCentralPlusText", value: "ebook central plus" },
  { item: "advancedSearchFilterEbscoMasterfileText", value: "ebsco masterfile" },
  { item: "advancedSearchFilterEreolenText", value: "ereolen" },
  { item: "advancedSearchFilterEreolenGlobalText", value: "ereolen global" },
  { item: "advancedSearchFilterEreolenGlobalMagasinerText", value: "ereolen magazines" },
  // { item: "advancedSearchFilterEreolenGlobalNetlydboegerText", value: "ereolen global lydbog" },
  // { item: "advancedSearchFilterEreolenLicensText", value: "ereolen licens" },
  { item: "advancedSearchFilterFaktalinkArtikelbasenText", value: "faktalink" },
  { item: "advancedSearchFilterFilmstribenText", value: "filmstriben" },
  // { item: "advancedSearchFilterFilmstribenPaaBiblioteketText", value: "filmstriben på biblioteket" },
  { item: "advancedSearchFilterForfatterwebArtikelbasenText", value: "forfatterweb" },
  // { item: "advancedSearchFilterGyldensdalsRoedeOrdboegerText", value: "ordbogen.com" },
  { item: "advancedSearchFilterHistoriensVerdenText", value: "historiens verden" },
  { item: "advancedSearchFilterHistoriskAtlasText", value: "historisk atlas" },
  { item: "advancedSearchFilterKbEboegerText", value: "kb e-bøger" },
  { item: "advancedSearchFilterGaleLiteratureResourceCenterText", value: "gale literature resource center" },
  { item: "advancedSearchFilterLitteratursidenAnalyserText", value: "litteratursiden" },
  // { item: "advancedSearchFilterLitteratursidenAnmeldelserText", value: "litteratursiden anmeldelser" },
  // { item: "advancedSearchFilterLitteratursidenArtiklerText", value: "litteratursiden artikler" },
  // { item: "advancedSearchFilterLitteratursidenForfatterportraetterText", value: "forfatterportrætter" },
  { item: "advancedSearchFilterMaterialevurderingerText", value: "materialevurderinger" },
  { item: "advancedSearchFilterMediciTvText", value: "medici.tv" },
  { item: "advancedSearchFilterNaxosMusicLibraryText", value: "naxos" },
  { item: "advancedSearchFilterNetlydbogText", value: "netlydbog" },
  // { item: "advancedSearchFilterOverbygningsmaterialerText", value: "overbygningsmaterialer" },
  { item: "advancedSearchFilterPressreaderText", value: "pressreader" },
  { item: "advancedSearchFilterScienceInContextReferenceText", value: "science in context" },
  // { item: "advancedSearchFilterSeismoText", value: "seismo" },
  { item: "advancedSearchFilterTidsskriftDkText", value: "tidsskrift.dk" },
  { item: "advancedSearchFilterTransparentLanguageOnlineText", value: "transparent language online" },
];

export const advancedSearchAgeGroups: MultiselectOption[] = [
  { item: "advancedSearchFilterGroupOneText", value: "1 2" },
  { item: "advancedSearchFilterGroupTwoText", value: "3 6" },
  { item: "advancedSearchFilterGroupThreeText", value: "7 10" },
  { item: "advancedSearchFilterGroupFourText", value: "11 13" },
  { item: "advancedSearchFilterGroupFiveText", value: "14 16" }
];

export const advancedSearchPublicationYearGroups: MultiselectOption[] = [
  { item: "advancedSearchFilterPublicationYearGroupOneText", value: "NOW - 12 MONTHS NOW" },
  { item: "advancedSearchFilterPublicationYearGroupTwoText", value: "NOW - 24 MONTHS NOW" },
  { item: "advancedSearchFilterPublicationYearGroupThreeText", value: "NOW - 36 MONTHS NOW" },
  { item: "advancedSearchFilterPublicationYearGroupFourText", value: "NOW - 60 MONTHS NOW" },
  { item: "advancedSearchFilterPublicationYearGroupFiveText", value: "NOW - 120 MONTHS NOW" }
];

export const advancedSearchFiction: MultiselectOption[] = [
  { item: "advancedSearchFilterFictionText", value: "fiction" },
  { item: "advancedSearchFilterNonFictionText", value: "nonfiction" }
];

export const advancedSearchMood: MultiselectOption[] = [
  { item: "advancedSearchFilterMoodEntusiastiskText", value: "entusiastisk" },
  { item: "advancedSearchFilterMoodPositivText", value: "positiv" },
  { item: "advancedSearchFilterMoodEuforiskText", value: "euforisk" },
  { item: "advancedSearchFilterMoodGladText", value: "glad" },
  { item: "advancedSearchFilterMoodInspirerendeText", value: "inspirerende" },
  { item: "advancedSearchFilterMoodTrygText", value: "tryg" },
  { item: "advancedSearchFilterMoodVarmText", value: "varm" },
  { item: "advancedSearchFilterMoodHyggeligText", value: "hyggelig" },
  { item: "advancedSearchFilterMoodOptimistiskText", value: "optimistisk" },
  { item: "advancedSearchFilterMoodSoergmunterText", value: "sørgmunter" },
  { item: "advancedSearchFilterMoodFjolletText", value: "fjollet" },
  { item: "advancedSearchFilterMoodSatiriskText", value: "satirisk" },
  { item: "advancedSearchFilterMoodToerHumorText", value: "tør humor" },
  { item: "advancedSearchFilterMoodSkaelmskText", value: "skælmsk" },
  { item: "advancedSearchFilterMoodLunHumorText", value: "lun humor" },
  { item: "advancedSearchFilterMoodSarkastiskText", value: "sarkastisk" },
  { item: "advancedSearchFilterMoodGroteskText", value: "grotesk" },
  { item: "advancedSearchFilterMoodIroniskText", value: "ironisk" },
  { item: "advancedSearchFilterMoodHumoristiskText", value: "humoristisk" },
  { item: "advancedSearchFilterMoodKomiskText", value: "komisk" },
  { item: "advancedSearchFilterMoodLatrinaerText", value: "latrinær" },
  { item: "advancedSearchFilterMoodSortHumorText", value: "sort humor" },
  { item: "advancedSearchFilterMoodCharmerendeText", value: "charmerende" },
  { item: "advancedSearchFilterMoodKaerligText", value: "kærlig" },
  { item: "advancedSearchFilterMoodLidenskabeligText", value: "lidenskabelig" },
  { item: "advancedSearchFilterMoodRomantiskText", value: "romantisk" },
  { item: "advancedSearchFilterMoodFoelsomText", value: "følsom" },
  { item: "advancedSearchFilterMoodSanseligText", value: "sanselig" },
  { item: "advancedSearchFilterMoodFortryllendeText", value: "fortryllende" },
  { item: "advancedSearchFilterMoodSoedText", value: "sød" },
  { item: "advancedSearchFilterMoodForfoerendeText", value: "forførende" },
  { item: "advancedSearchFilterMoodPikantText", value: "pikant" },
  { item: "advancedSearchFilterMoodSexetText", value: "sexet" },
  { item: "advancedSearchFilterMoodErotiskText", value: "erotisk" },
  { item: "advancedSearchFilterMoodPornografiskText", value: "pornografisk" },
  { item: "advancedSearchFilterMoodAnspaendtText", value: "anspændt" },
  { item: "advancedSearchFilterMoodGraensesoegendeText", value: "grænsesøgende" },
  { item: "advancedSearchFilterMoodFoelelsesladetText", value: "følelsesladet" },
  { item: "advancedSearchFilterMoodDramatiskText", value: "dramatisk" },
  { item: "advancedSearchFilterMoodBevaegendeText", value: "bevægende" },
  { item: "advancedSearchFilterMoodGribendeText", value: "gribende" },
  { item: "advancedSearchFilterMoodAggressivText", value: "aggressiv" },
  { item: "advancedSearchFilterMoodOprivendeText", value: "oprivende" },
  { item: "advancedSearchFilterMoodOverraskendeText", value: "overraskende" },
  { item: "advancedSearchFilterMoodSkaebnesvangerText", value: "skæbnesvanger" },
  { item: "advancedSearchFilterMoodVredText", value: "vred" },
  { item: "advancedSearchFilterMoodSpaendendeText", value: "spændende" },
  { item: "advancedSearchFilterMoodDeprimerendeText", value: "deprimerende" },
  { item: "advancedSearchFilterMoodBittersoedText", value: "bittersød" },
  { item: "advancedSearchFilterMoodDysterText", value: "dyster" },
  { item: "advancedSearchFilterMoodHaabloesText", value: "håbløs" },
  { item: "advancedSearchFilterMoodSoergeligText", value: "sørgelig" },
  { item: "advancedSearchFilterMoodMelankolskText", value: "melankolsk" },
  { item: "advancedSearchFilterMoodMeningsloesText", value: "meningsløs" },
  { item: "advancedSearchFilterMoodSmertefuldText", value: "smertefuld" },
  { item: "advancedSearchFilterMoodTragiskText", value: "tragisk" },
  { item: "advancedSearchFilterMoodTristText", value: "trist" },
  { item: "advancedSearchFilterMoodVemodigText", value: "vemodig" },
  { item: "advancedSearchFilterMoodBarskText", value: "barsk" },
  { item: "advancedSearchFilterMoodNostalgiskText", value: "nostalgisk" },
  { item: "advancedSearchFilterMoodForuroligendeText", value: "foruroligende" },
  { item: "advancedSearchFilterMoodBlodigText", value: "blodig" },
  { item: "advancedSearchFilterMoodDystopiskText", value: "dystopisk" },
  { item: "advancedSearchFilterMoodHaarrejsendeText", value: "hårrejsende" },
  { item: "advancedSearchFilterMoodKlaustrofobiskText", value: "klaustrofobisk" },
  { item: "advancedSearchFilterMoodOndskabsfuldText", value: "ondskabsfuld" },
  { item: "advancedSearchFilterMoodKyniskText", value: "kynisk" },
  { item: "advancedSearchFilterMoodUhyggeligText", value: "uhyggelig" },
  { item: "advancedSearchFilterMoodVoldeligText", value: "voldelig" },
  { item: "advancedSearchFilterMoodFrastoedendeText", value: "frastødende" },
  { item: "advancedSearchFilterMoodPsykopatiskText", value: "psykopatisk" },
  { item: "advancedSearchFilterMoodFrygtindgydendeText", value: "frygtindgydende" },
  { item: "advancedSearchFilterMoodUbehageligText", value: "ubehagelig" },
  { item: "advancedSearchFilterMoodMystiskText", value: "mystisk" },
  { item: "advancedSearchFilterMoodEksotiskText", value: "eksotisk" },
  { item: "advancedSearchFilterMoodEventyrligText", value: "eventyrlig" },
  { item: "advancedSearchFilterMoodMagiskText", value: "magisk" },
  { item: "advancedSearchFilterMoodFantasifuldText", value: "fantasifuld" },
  { item: "advancedSearchFilterMoodFarverigText", value: "farverig" },
  { item: "advancedSearchFilterMoodAllegoriskText", value: "allegorisk" },
  { item: "advancedSearchFilterMoodAnderledesText", value: "anderledes" },
  { item: "advancedSearchFilterMoodNyskabendeText", value: "nyskabende" },
  { item: "advancedSearchFilterMoodMytiskText", value: "mytisk" },
  { item: "advancedSearchFilterMoodSkaevText", value: "skæv" },
  { item: "advancedSearchFilterMoodMaerkeligText", value: "mærkelig" },
  { item: "advancedSearchFilterMoodDybsindigText", value: "dybsindig" },
  { item: "advancedSearchFilterMoodHoejtideligText", value: "højtidelig" },
  { item: "advancedSearchFilterMoodFilosofiskText", value: "filosofisk" },
  { item: "advancedSearchFilterMoodReflekterendeText", value: "reflekterende" },
  { item: "advancedSearchFilterMoodReligioesText", value: "religiøs" },
  { item: "advancedSearchFilterMoodIntellektuelText", value: "intellektuel" },
  { item: "advancedSearchFilterMoodRaesonnerendeText", value: "ræsonnerende" },
  { item: "advancedSearchFilterMoodIntelligentText", value: "intelligent" },
  { item: "advancedSearchFilterMoodSpirituelText", value: "spirituel" },
  { item: "advancedSearchFilterMoodKontroversielText", value: "kontroversiel" },
  { item: "advancedSearchFilterMoodOplysendeText", value: "oplysende" },
  { item: "advancedSearchFilterMoodObserverendeText", value: "observerende" },
  { item: "advancedSearchFilterMoodPsykologiskText", value: "psykologisk" },
  { item: "advancedSearchFilterMoodTankevaekkendeText", value: "tankevækkende" },
];

export const advancedSearchLanguage: MultiselectOption[] = [
  { item: "advancedSearchFilterLanguageDanskText", value: "dansk" },
  { item: "advancedSearchFilterLanguageEngelskText", value: "engelsk" },
  { item: "advancedSearchFilterLanguageTyskText", value: "tysk" },
  { item: "advancedSearchFilterLanguageFranskText", value: "fransk" },
  { item: "advancedSearchFilterLanguageSvenskText", value: "svensk" },
  { item: "advancedSearchFilterLanguageNorskText", value: "norsk" },
  { item: "advancedSearchFilterLanguageFaeroeskText", value: "færøsk" },
  { item: "advancedSearchFilterLanguageGroenlandskText", value: "grønlandsk" },
  { item: "advancedSearchFilterLanguageArabiskText", value: "arabisk" },
  { item: "advancedSearchFilterLanguageUkrainskText", value: "ukrainsk" },
  { item: "advancedSearchFilterLanguageAfrikaansText", value: "afrikaans" },
  { item: "advancedSearchFilterLanguageAfrikanskeSprogSydForSaharaText", value: "afrikanske sprog syd for sahara (øvrige)" },
  { item: "advancedSearchFilterLanguageAkkadiskText", value: "akkadisk" },
  { item: "advancedSearchFilterLanguageAlbanskText", value: "albansk" },
  { item: "advancedSearchFilterLanguageAleutiskText", value: "aleutisk" },
  { item: "advancedSearchFilterLanguageAltaiskeSprogText", value: "altaiske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageAmhariskText", value: "amharisk" },
  { item: "advancedSearchFilterLanguageAngelsaksiskText", value: "angelsaksisk" },
  { item: "advancedSearchFilterLanguageAramaeiskText", value: "aramæisk" },
  { item: "advancedSearchFilterLanguageArmenskText", value: "armensk" },
  { item: "advancedSearchFilterLanguageAserbajdsjanskText", value: "aserbajdsjansk" },
  { item: "advancedSearchFilterLanguageAustralskeSprogText", value: "australske sprog" },
  { item: "advancedSearchFilterLanguageAvestiskText", value: "avestisk" },
  { item: "advancedSearchFilterLanguageBaluchiskText", value: "baluchisk" },
  { item: "advancedSearchFilterLanguageBambaraText", value: "bambara" },
  { item: "advancedSearchFilterLanguageBaskiskText", value: "baskisk" },
  { item: "advancedSearchFilterLanguageBatakText", value: "batak" },
  { item: "advancedSearchFilterLanguageBelarusiskText", value: "belarusisk" },
  { item: "advancedSearchFilterLanguageBengaliText", value: "bengali" },
  { item: "advancedSearchFilterLanguageBerberiskeSprogText", value: "berberiske sprog" },
  { item: "advancedSearchFilterLanguageBosniskText", value: "bosnisk" },
  { item: "advancedSearchFilterLanguageBretonskText", value: "bretonsk" },
  { item: "advancedSearchFilterLanguageBulgarskText", value: "bulgarsk" },
  { item: "advancedSearchFilterLanguageBurmesiskText", value: "burmesisk" },
  { item: "advancedSearchFilterLanguageCatalanskText", value: "catalansk" },
  { item: "advancedSearchFilterLanguageCorniskText", value: "cornisk" },
  { item: "advancedSearchFilterLanguageDariText", value: "dari" },
  { item: "advancedSearchFilterLanguageEgyptiskText", value: "egyptisk" },
  { item: "advancedSearchFilterLanguageEngelskMiddelText", value: "engelsk, middel- (ca. 1100-1500)" },
  { item: "advancedSearchFilterLanguageEskimoiskText", value: "eskimoisk" },
  { item: "advancedSearchFilterLanguageEsperantoText", value: "esperanto" },
  { item: "advancedSearchFilterLanguageEstiskText", value: "estisk" },
  { item: "advancedSearchFilterLanguageFinskText", value: "finsk" },
  { item: "advancedSearchFilterLanguageFinskUgriskeText", value: "finsk-ugriske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageFlereSprogText", value: "flere sprog" },
  { item: "advancedSearchFilterLanguageFranskMiddelText", value: "fransk, middel- (ca. 1450-1600)" },
  { item: "advancedSearchFilterLanguageFranskOldText", value: "fransk, old- (ca. 842-1400)" },
  { item: "advancedSearchFilterLanguageFrisiskText", value: "frisisk" },
  { item: "advancedSearchFilterLanguageGaliciskText", value: "galicisk" },
  { item: "advancedSearchFilterLanguageGeorgiskText", value: "georgisk" },
  { item: "advancedSearchFilterLanguageGermanskeSprogText", value: "germanske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageGeezText", value: "ge’ez" },
  { item: "advancedSearchFilterLanguageGotiskText", value: "gotisk" },
  { item: "advancedSearchFilterLanguageGraeskText", value: "græsk" },
  { item: "advancedSearchFilterLanguageGraeskOldText", value: "græsk, old- (til 1453)" },
  { item: "advancedSearchFilterLanguageGujaratiText", value: "gujarati" },
  { item: "advancedSearchFilterLanguageHausaText", value: "hausa" },
  { item: "advancedSearchFilterLanguageHawaiianskText", value: "hawaiiansk" },
  { item: "advancedSearchFilterLanguageHebraiskText", value: "hebraisk" },
  { item: "advancedSearchFilterLanguageHindiText", value: "hindi" },
  { item: "advancedSearchFilterLanguageHittitiskText", value: "hittitisk" },
  { item: "advancedSearchFilterLanguageIkkeLinguistiskIndholdText", value: "ikke linguistisk indhold" },
  { item: "advancedSearchFilterLanguageIndoariskeSprogText", value: "indoariske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageIndonesiskText", value: "indonesisk" },
  { item: "advancedSearchFilterLanguageInterlinguaText", value: "interlingua" },
  { item: "advancedSearchFilterLanguageInuktitutText", value: "inuktitut" },
  { item: "advancedSearchFilterLanguageInupiaqText", value: "inupiaq" },
  { item: "advancedSearchFilterLanguageIranskeSprogText", value: "iranske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageIrskText", value: "irsk" },
  { item: "advancedSearchFilterLanguageIrskMiddelText", value: "irsk, middel- (900-1200)" },
  { item: "advancedSearchFilterLanguageIslandskText", value: "islandsk" },
  { item: "advancedSearchFilterLanguageItalienskText", value: "italiensk" },
  { item: "advancedSearchFilterLanguageJapanskText", value: "japansk" },
  { item: "advancedSearchFilterLanguageJavanesiskText", value: "javanesisk" },
  { item: "advancedSearchFilterLanguageJiddischText", value: "jiddisch" },
  { item: "advancedSearchFilterLanguageJoediskArabiskText", value: "jødisk-arabisk" },
  { item: "advancedSearchFilterLanguageJoediskPersiskText", value: "jødisk-persisk" },
  { item: "advancedSearchFilterLanguageKalaallisutText", value: "kalaallisut" },
  { item: "advancedSearchFilterLanguageKasakhiskText", value: "kasakhisk" },
  { item: "advancedSearchFilterLanguageKaukasiskeSprogText", value: "kaukasiske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageKeltiskeSprogText", value: "keltiske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageKhmerText", value: "khmer" },
  { item: "advancedSearchFilterLanguageKinesiskText", value: "kinesisk" },
  { item: "advancedSearchFilterLanguageKinyarwandaText", value: "kinyarwanda" },
  { item: "advancedSearchFilterLanguageKirgisiskText", value: "kirgisisk" },
  { item: "advancedSearchFilterLanguageKirkeslaviskText", value: "kirkeslavisk" },
  { item: "advancedSearchFilterLanguageKoptiskText", value: "koptisk" },
  { item: "advancedSearchFilterLanguageKoreanskText", value: "koreansk" },
  { item: "advancedSearchFilterLanguageKreolskOgPidginText", value: "kreolsk og pidgin (øvrige)" },
  { item: "advancedSearchFilterLanguageKreolskOgPidginFranskText", value: "kreolsk og pidgin, baseret på fransk (øvrige)" },
  { item: "advancedSearchFilterLanguageKreolskOgPidginPortugisiskText", value: "kreolsk og pidgin, baseret på portugisisk (øvrige)" },
  { item: "advancedSearchFilterLanguageKroatiskText", value: "kroatisk" },
  { item: "advancedSearchFilterLanguageKunstsprogText", value: "kunstsprog (øvrige)" },
  { item: "advancedSearchFilterLanguageKurdiskText", value: "kurdisk" },
  { item: "advancedSearchFilterLanguageKurmanciText", value: "kurmanci" },
  { item: "advancedSearchFilterLanguageLadinoText", value: "ladino" },
  { item: "advancedSearchFilterLanguageLaotiskText", value: "laotisk" },
  { item: "advancedSearchFilterLanguageLatinText", value: "latin" },
  { item: "advancedSearchFilterLanguageLettiskText", value: "lettisk" },
  { item: "advancedSearchFilterLanguageLingalaText", value: "lingala" },
  { item: "advancedSearchFilterLanguageLitauiskText", value: "litauisk" },
  { item: "advancedSearchFilterLanguageMakedonskText", value: "makedonsk" },
  { item: "advancedSearchFilterLanguageMalagassiskText", value: "malagassisk" },
  { item: "advancedSearchFilterLanguageMalajiskText", value: "malajisk" },
  { item: "advancedSearchFilterLanguageMalajoPolynesiskeSprogText", value: "malajo-polynesiske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageMalayalamText", value: "malayalam" },
  { item: "advancedSearchFilterLanguageMaltesiskText", value: "maltesisk" },
  { item: "advancedSearchFilterLanguageMandingSprogText", value: "manding sprog" },
  { item: "advancedSearchFilterLanguageMaoriText", value: "maori" },
  { item: "advancedSearchFilterLanguageMarathiText", value: "marathi" },
  { item: "advancedSearchFilterLanguageMayasprogText", value: "mayasprog" },
  { item: "advancedSearchFilterLanguageMellemamerikanskeSprogText", value: "mellemamerikanske indianske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageMiddelpersiskText", value: "middelpersisk" },
  { item: "advancedSearchFilterLanguageMoldoviskText", value: "moldovisk" },
  { item: "advancedSearchFilterLanguageMongolskText", value: "mongolsk" },
  { item: "advancedSearchFilterLanguageNahuatlText", value: "nahuatl" },
  { item: "advancedSearchFilterLanguageNederlandskText", value: "nederlandsk" },
  { item: "advancedSearchFilterLanguageNederlandskMiddelText", value: "nederlandsk, middel- (ca. 1050-1350)" },
  { item: "advancedSearchFilterLanguageNepalesiskText", value: "nepalesisk" },
  { item: "advancedSearchFilterLanguageNewariText", value: "newari" },
  { item: "advancedSearchFilterLanguageNigerCongoText", value: "niger-congo sprog" },
  { item: "advancedSearchFilterLanguageNordamerikanskeIndianskeSprogText", value: "nordamerikanske indianske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageNorroentText", value: "norrønt" },
  { item: "advancedSearchFilterLanguageNorskBokmaalText", value: "norsk bokmål" },
  { item: "advancedSearchFilterLanguageNorskNynorskText", value: "norsk nynorsk" },
  { item: "advancedSearchFilterLanguageNubiskeSprogText", value: "nubiske sprog" },
  { item: "advancedSearchFilterLanguageNysyriskText", value: "nysyrisk" },
  { item: "advancedSearchFilterLanguageOccitanskText", value: "occitansk (efter 1500)" },
  { item: "advancedSearchFilterLanguageOldirskText", value: "oldirsk" },
  { item: "advancedSearchFilterLanguageOldoccitanskText", value: "oldoccitansk (før 1500)" },
  { item: "advancedSearchFilterLanguageOsmanniskTyrkiskText", value: "osmannisk-tyrkisk (1500-1928)" },
  { item: "advancedSearchFilterLanguageOssetiskText", value: "ossetisk" },
  { item: "advancedSearchFilterLanguagePaliText", value: "pali" },
  { item: "advancedSearchFilterLanguagePapuasprogText", value: "papuasprog (øvrige)" },
  { item: "advancedSearchFilterLanguagePashtoText", value: "pashto" },
  { item: "advancedSearchFilterLanguagePersiskText", value: "persisk" },
  { item: "advancedSearchFilterLanguagePlattyskText", value: "plattysk" },
  { item: "advancedSearchFilterLanguagePolskText", value: "polsk" },
  { item: "advancedSearchFilterLanguagePortugisiskText", value: "portugisisk" },
  { item: "advancedSearchFilterLanguagePrakritLanguagesText", value: "prakrit languages" },
  { item: "advancedSearchFilterLanguagePunjabiText", value: "punjabi" },
  { item: "advancedSearchFilterLanguageQuechuaText", value: "quechua" },
  { item: "advancedSearchFilterLanguageRomaniText", value: "romani" },
  { item: "advancedSearchFilterLanguageRomanskeSprogText", value: "romanske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageRumaenskText", value: "rumænsk" },
  { item: "advancedSearchFilterLanguageRussiskText", value: "russisk" },
  { item: "advancedSearchFilterLanguageRaetoromanskText", value: "rætoromansk" },
  { item: "advancedSearchFilterLanguageSamaritanskAramaeiskText", value: "samaritansk aramæisk" },
  { item: "advancedSearchFilterLanguageSamiskeSprogText", value: "samiske sprog" },
  { item: "advancedSearchFilterLanguageSanskritText", value: "sanskrit" },
  { item: "advancedSearchFilterLanguageSantaliText", value: "santali" },
  { item: "advancedSearchFilterLanguageSemitiskeSprogText", value: "semitiske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageSerbiskText", value: "serbisk" },
  { item: "advancedSearchFilterLanguageSerbokroatiskText", value: "serbokroatisk" },
  { item: "advancedSearchFilterLanguageShonaText", value: "shona" },
  { item: "advancedSearchFilterLanguageSingalesiskText", value: "singalesisk" },
  { item: "advancedSearchFilterLanguageSinoTibetanskeSprogText", value: "sino-tibetanske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageSkotskText", value: "skotsk" },
  { item: "advancedSearchFilterLanguageSkotskGaeliskText", value: "skotsk gælisk" },
  { item: "advancedSearchFilterLanguageSlaveyText", value: "slavey (athabascan)" },
  { item: "advancedSearchFilterLanguageSlaviskeSprogText", value: "slaviske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageSlovakiskText", value: "slovakisk" },
  { item: "advancedSearchFilterLanguageSlovenskText", value: "slovensk" },
  { item: "advancedSearchFilterLanguageSomaliText", value: "somali" },
  { item: "advancedSearchFilterLanguageSoraniText", value: "sorani" },
  { item: "advancedSearchFilterLanguageSorbiskeSprogText", value: "sorbiske sprog" },
  { item: "advancedSearchFilterLanguageSothoText", value: "sotho" },
  { item: "advancedSearchFilterLanguageSpanskText", value: "spansk" },
  { item: "advancedSearchFilterLanguageSprogetKanIkkeBestemmesText", value: "sproget kan ikke bestemmes" },
  { item: "advancedSearchFilterLanguageSumeriskText", value: "sumerisk" },
  { item: "advancedSearchFilterLanguageSwahiliText", value: "swahili" },
  { item: "advancedSearchFilterLanguageSydamerikanskeIndianskeSprogText", value: "sydamerikanske indianske sprog (øvrige)" },
  { item: "advancedSearchFilterLanguageSyriskText", value: "syrisk" },
  { item: "advancedSearchFilterLanguageTadsjikiskText", value: "tadsjikisk" },
  { item: "advancedSearchFilterLanguageTagalogText", value: "tagalog" },
  { item: "advancedSearchFilterLanguageTaiText", value: "tai (øvrige)" },
  { item: "advancedSearchFilterLanguageTamashekText", value: "tamashek" },
  { item: "advancedSearchFilterLanguageTamilText", value: "tamil" },
  { item: "advancedSearchFilterLanguageTatariskText", value: "tatarisk" },
  { item: "advancedSearchFilterLanguageTeluguText", value: "telugu" },
  { item: "advancedSearchFilterLanguageThaiText", value: "thai" },
  { item: "advancedSearchFilterLanguageTibetanskText", value: "tibetansk" },
  { item: "advancedSearchFilterLanguageTigrinskText", value: "tigrinsk" },
  { item: "advancedSearchFilterLanguageTjekkiskText", value: "tjekkisk" },
  { item: "advancedSearchFilterLanguageTjetjenskText", value: "tjetjensk" },
  { item: "advancedSearchFilterLanguageTurkmenskText", value: "turkmensk" },
  { item: "advancedSearchFilterLanguageTyrkiskText", value: "tyrkisk" },
  { item: "advancedSearchFilterLanguageTyskMiddelhoejText", value: "tysk, middelhøj- (ca. 1050-1500)" },
  { item: "advancedSearchFilterLanguageTyskOldhoejText", value: "tysk, oldhøj- (ca. 750-1050)" },
  { item: "advancedSearchFilterLanguageUgaritiskText", value: "ugaritisk" },
  { item: "advancedSearchFilterLanguageUiguriskText", value: "uigurisk" },
  { item: "advancedSearchFilterLanguageUngarskText", value: "ungarsk" },
  { item: "advancedSearchFilterLanguageUrduText", value: "urdu" },
  { item: "advancedSearchFilterLanguageUsbekiskText", value: "usbekisk" },
  { item: "advancedSearchFilterLanguageVietnamesiskText", value: "vietnamesisk" },
  { item: "advancedSearchFilterLanguageWalisiskText", value: "walisisk" },
  { item: "advancedSearchFilterLanguageWolofText", value: "wolof" },
  { item: "advancedSearchFilterLanguageXhosaText", value: "xhosa" },
  { item: "advancedSearchFilterLanguageYorubaText", value: "yoruba" },
  { item: "advancedSearchFilterLanguageYupiksprogText", value: "yupiksprog" },
  { item: "advancedSearchFilterLanguageZuluText", value: "zulu" },
];

export const advancedSearchGenreAndForm: MultiselectOption[] = [
  { item: "advancedSearchFilterGenreAndFormRomanText", value: "roman" },
  { item: "advancedSearchFilterGenreAndFormNovellerText", value: "noveller" },
  { item: "advancedSearchFilterGenreAndFormDigteText", value: "digte" },
  { item: "advancedSearchFilterGenreAndFormBiografierText", value: "biografier" },
  { item: "advancedSearchFilterGenreAndFormKrimiText", value: "krimi" },
  { item: "advancedSearchFilterGenreAndFormFantasyText", value: "fantasy" },
  { item: "advancedSearchFilterGenreAndFormSpaendingText", value: "spænding" },
  { item: "advancedSearchFilterGenreAndFormRomantikText", value: "romantik" },
  { item: "advancedSearchFilterGenreAndFormHumorText", value: "humor" },
  { item: "advancedSearchFilterGenreAndFormStrikkeopskrifterText", value: "strikkeopskrifter" },
  { item: "advancedSearchFilterGenreAndFormOpskrifterText", value: "opskrifter" },
  { item: "advancedSearchFilterGenreAndFormRejseguidesText", value: "rejseguides" },
  { item: "advancedSearchFilterGenreAndFormAforismerText", value: "aforismer" },
  { item: "advancedSearchFilterGenreAndFormAllegorierText", value: "allegorier" },
  { item: "advancedSearchFilterGenreAndFormAnalyserText", value: "analyser" },
  { item: "advancedSearchFilterGenreAndFormAndagtsboegerText", value: "andagtsbøger" },
  { item: "advancedSearchFilterGenreAndFormAtlasText", value: "atlas" },
  { item: "advancedSearchFilterGenreAndFormBageboegerText", value: "bagebøger" },
  { item: "advancedSearchFilterGenreAndFormBarnabókText", value: "barnabók" },
  { item: "advancedSearchFilterGenreAndFormBarndomserindringerText", value: "barndomserindringer" },
  { item: "advancedSearchFilterGenreAndFormBekendtgoerelserText", value: "bekendtgørelser" },
  { item: "advancedSearchFilterGenreAndFormBeretningerText", value: "beretninger" },
  { item: "advancedSearchFilterGenreAndFormBetaenkningerText", value: "betænkninger" },
  { item: "advancedSearchFilterGenreAndFormBibelfortolkningerText", value: "bibelfortolkninger" },
  { item: "advancedSearchFilterGenreAndFormBibelhistorierText", value: "bibelhistorier" },
  { item: "advancedSearchFilterGenreAndFormBibelstudierText", value: "bibelstudier" },
  { item: "advancedSearchFilterGenreAndFormBibliografierText", value: "bibliografier" },
  { item: "advancedSearchFilterGenreAndFormBilledbogText", value: "billedbog" },
  { item: "advancedSearchFilterGenreAndFormBilledbogIFarverText", value: "billedbog i farver" },
  { item: "advancedSearchFilterGenreAndFormBilledboegerText", value: "billedbøger" },
  { item: "advancedSearchFilterGenreAndFormBilledordboegerText", value: "billedordbøger" },
  { item: "advancedSearchFilterGenreAndFormBilledvaerkText", value: "billedværk" },
  { item: "advancedSearchFilterGenreAndFormBilledvaerkerText", value: "billedværker" },
  { item: "advancedSearchFilterGenreAndFormBiografiText", value: "biografi" },
  { item: "advancedSearchFilterGenreAndFormBiografiskeRomanerText", value: "biografiske romaner" },
  { item: "advancedSearchFilterGenreAndFormBlandedeSkrifterText", value: "blandede skrifter" },
  { item: "advancedSearchFilterGenreAndFormBreveText", value: "breve" },
  { item: "advancedSearchFilterGenreAndFormBroderimoenstreText", value: "broderimønstre" },
  { item: "advancedSearchFilterGenreAndFormBoernesangeText", value: "børnesange" },
  { item: "advancedSearchFilterGenreAndFormChickLitText", value: "chick lit" },
  { item: "advancedSearchFilterGenreAndFormCitaterText", value: "citater" },
  { item: "advancedSearchFilterGenreAndFormDagboegerText", value: "dagbøger" },
  { item: "advancedSearchFilterGenreAndFormDarkFantasyText", value: "dark fantasy" },
  { item: "advancedSearchFilterGenreAndFormDisputatserText", value: "disputatser" },
  { item: "advancedSearchFilterGenreAndFormDiaetkogeboegerText", value: "diætkogebøger" },
  { item: "advancedSearchFilterGenreAndFormDramatikText", value: "dramatik" },
  { item: "advancedSearchFilterGenreAndFormDuErSelvHovedpersonenText", value: "du er selv hovedpersonen" },
  { item: "advancedSearchFilterGenreAndFormDyrefortaellingerText", value: "dyrefortællinger" },
  { item: "advancedSearchFilterGenreAndFormDystopierText", value: "dystopier" },
  { item: "advancedSearchFilterGenreAndFormEksamensopgaverUnderDisputatsniveauText", value: "eksamensopgaver under disputatsniveau" },
  { item: "advancedSearchFilterGenreAndFormEksperimenterendeLitteraturText", value: "eksperimenterende litteratur" },
  { item: "advancedSearchFilterGenreAndFormEncyklopaedierText", value: "encyklopædier" },
  { item: "advancedSearchFilterGenreAndFormErindringerText", value: "erindringer" },
  { item: "advancedSearchFilterGenreAndFormErotiskeRomanerText", value: "erotiske romaner" },
  { item: "advancedSearchFilterGenreAndFormEssayText", value: "essay(s)" },
  { item: "advancedSearchFilterGenreAndFormEssaysText", value: "essays" },
  { item: "advancedSearchFilterGenreAndFormEventyrText", value: "eventyr" },
  { item: "advancedSearchFilterGenreAndFormEventyrligeFortaellingerText", value: "eventyrlige fortællinger" },
  { item: "advancedSearchFilterGenreAndFormFablerText", value: "fabler" },
  { item: "advancedSearchFilterGenreAndFormFantastiskeFortaellingerText", value: "fantastiske fortællinger" },
  { item: "advancedSearchFilterGenreAndFormFestskrifterText", value: "festskrifter" },
  { item: "advancedSearchFilterGenreAndFormFilmanalyserText", value: "filmanalyser" },
  { item: "advancedSearchFilterGenreAndFormFilmmanuskripterText", value: "filmmanuskripter" },
  { item: "advancedSearchFilterGenreAndFormFilosofiskeSkrifterText", value: "filosofiske skrifter" },
  { item: "advancedSearchFilterGenreAndFormForedragText", value: "foredrag" },
  { item: "advancedSearchFilterGenreAndFormForsoegText", value: "forsøg" },
  { item: "advancedSearchFilterGenreAndFormForsoegsrapporterText", value: "forsøgsrapporter" },
  { item: "advancedSearchFilterGenreAndFormFortegnelserText", value: "fortegnelser" },
  { item: "advancedSearchFilterGenreAndFormFortolkningerText", value: "fortolkninger" },
  { item: "advancedSearchFilterGenreAndFormFortaellingText", value: "fortælling" },
  { item: "advancedSearchFilterGenreAndFormFortaellingerText", value: "fortællinger" },
  { item: "advancedSearchFilterGenreAndFormFotografierText", value: "fotografier" },
  { item: "advancedSearchFilterGenreAndFormFotografiskBilledvaerkText", value: "fotografisk billedværk" },
  { item: "advancedSearchFilterGenreAndFormFremtidsfortaellingerText", value: "fremtidsfortællinger" },
  { item: "advancedSearchFilterGenreAndFormFoeleboegerText", value: "følebøger" },
  { item: "advancedSearchFilterGenreAndFormGodnathistorierText", value: "godnathistorier" },
  { item: "advancedSearchFilterGenreAndFormGrammatikkerText", value: "grammatikker" },
  { item: "advancedSearchFilterGenreAndFormGraphicNovelsText", value: "graphic novels" },
  { item: "advancedSearchFilterGenreAndFormGuidesText", value: "guides" },
  { item: "advancedSearchFilterGenreAndFormGysText", value: "gys" },
  { item: "advancedSearchFilterGenreAndFormGaaPaaOpdagelseText", value: "gå på opdagelse" },
  { item: "advancedSearchFilterGenreAndFormHandlingsplanerText", value: "handlingsplaner" },
  { item: "advancedSearchFilterGenreAndFormHelligeSkrifterText", value: "hellige skrifter" },
  { item: "advancedSearchFilterGenreAndFormHeltesagnText", value: "heltesagn" },
  { item: "advancedSearchFilterGenreAndFormHistoriskeRomanerText", value: "historiske romaner" },
  { item: "advancedSearchFilterGenreAndFormHorrorText", value: "horror" },
  { item: "advancedSearchFilterGenreAndFormHaandboegerText", value: "håndbøger" },
  { item: "advancedSearchFilterGenreAndFormHaekleopskrifterText", value: "hækleopskrifter" },
  { item: "advancedSearchFilterGenreAndFormIdeboegerText", value: "idebøger" },
  { item: "advancedSearchFilterGenreAndFormIdematerialerText", value: "idematerialer" },
  { item: "advancedSearchFilterGenreAndFormInterviewsText", value: "interviews" },
  { item: "advancedSearchFilterGenreAndFormJubilaeumsskriftText", value: "jubilæumsskrift" },
  { item: "advancedSearchFilterGenreAndFormJubilaeumsskrifterText", value: "jubilæumsskrifter" },
  { item: "advancedSearchFilterGenreAndFormKalenderhistorierText", value: "kalenderhistorier" },
  { item: "advancedSearchFilterGenreAndFormKatalogerText", value: "kataloger" },
  { item: "advancedSearchFilterGenreAndFormKatalogerBeholdningsbibliografiText", value: "kataloger (beholdningsbibliografi)" },
  { item: "advancedSearchFilterGenreAndFormKildesamlingerText", value: "kildesamlinger" },
  { item: "advancedSearchFilterGenreAndFormKogeboegerText", value: "kogebøger" },
  { item: "advancedSearchFilterGenreAndFormKompendierText", value: "kompendier" },
  { item: "advancedSearchFilterGenreAndFormKonferencerapporterText", value: "konferencerapporter" },
  { item: "advancedSearchFilterGenreAndFormKortText", value: "kort" },
  { item: "advancedSearchFilterGenreAndFormKostvejledningerText", value: "kostvejledninger" },
  { item: "advancedSearchFilterGenreAndFormKriminalromanText", value: "kriminalroman" },
  { item: "advancedSearchFilterGenreAndFormKaerlighedsromanerText", value: "kærlighedsromaner" },
  { item: "advancedSearchFilterGenreAndFormLandlivText", value: "landliv" },
  { item: "advancedSearchFilterGenreAndFormLeksikaText", value: "leksika" },
  { item: "advancedSearchFilterGenreAndFormLitteraturanalyserText", value: "litteraturanalyser" },
  { item: "advancedSearchFilterGenreAndFormLokalplanerText", value: "lokalplaner" },
  { item: "advancedSearchFilterGenreAndFormLoveText", value: "love" },
  { item: "advancedSearchFilterGenreAndFormLydretText", value: "lydret" },
  { item: "advancedSearchFilterGenreAndFormLaereboegerText", value: "lærebøger" },
  { item: "advancedSearchFilterGenreAndFormLaerervejledningerText", value: "lærervejledninger" },
  { item: "advancedSearchFilterGenreAndFormLaeseboegerText", value: "læsebøger" },
  { item: "advancedSearchFilterGenreAndFormLoeftOgKigText", value: "løft og kig" },
  { item: "advancedSearchFilterGenreAndFormMagiskRealismeText", value: "magisk realisme" },
  { item: "advancedSearchFilterGenreAndFormMangaText", value: "manga" },
  { item: "advancedSearchFilterGenreAndFormMuseumskatalogText", value: "museumskatalog" },
  { item: "advancedSearchFilterGenreAndFormMuseumskatalogerText", value: "museumskataloger" },
  { item: "advancedSearchFilterGenreAndFormMusikanalyserText", value: "musikanalyser" },
  { item: "advancedSearchFilterGenreAndFormMyterText", value: "myter" },
  { item: "advancedSearchFilterGenreAndFormMoenstreText", value: "mønstre" },
  { item: "advancedSearchFilterGenreAndFormNormerText", value: "normer" },
  { item: "advancedSearchFilterGenreAndFormNovelleText", value: "novelle" },
  { item: "advancedSearchFilterGenreAndFormNovellesamlingText", value: "novellesamling" },
  { item: "advancedSearchFilterGenreAndFormOpbyggeligLitteraturText", value: "opbyggelig litteratur" },
  { item: "advancedSearchFilterGenreAndFormOpgaverText", value: "opgaver" },
  { item: "advancedSearchFilterGenreAndFormOpslagsvaerkerText", value: "opslagsværker" },
  { item: "advancedSearchFilterGenreAndFormOrdboegerText", value: "ordbøger" },
  { item: "advancedSearchFilterGenreAndFormParloererText", value: "parlører" },
  { item: "advancedSearchFilterGenreAndFormPegeboegerText", value: "pegebøger" },
  { item: "advancedSearchFilterGenreAndFormPjecerText", value: "pjecer" },
  { item: "advancedSearchFilterGenreAndFormPolitiromanerText", value: "politiromaner" },
  { item: "advancedSearchFilterGenreAndFormProjektrapporterText", value: "projektrapporter" },
  { item: "advancedSearchFilterGenreAndFormPraedikenerText", value: "prædikener" },
  { item: "advancedSearchFilterGenreAndFormPsykologiskThrillerText", value: "psykologisk thriller" },
  { item: "advancedSearchFilterGenreAndFormQuizzerText", value: "quizzer" },
  { item: "advancedSearchFilterGenreAndFormRedegoerelserText", value: "redegørelser" },
  { item: "advancedSearchFilterGenreAndFormRegistranterText", value: "registranter" },
  { item: "advancedSearchFilterGenreAndFormRegistreText", value: "registre" },
  { item: "advancedSearchFilterGenreAndFormRejsebeskrivelserText", value: "rejsebeskrivelser" },
  { item: "advancedSearchFilterGenreAndFormRejsefoererText", value: "rejsefører" },
  { item: "advancedSearchFilterGenreAndFormRejseparloererText", value: "rejseparlører" },
  { item: "advancedSearchFilterGenreAndFormReligioeseBoegerText", value: "religiøse bøger" },
  { item: "advancedSearchFilterGenreAndFormRemserText", value: "remser" },
  { item: "advancedSearchFilterGenreAndFormReparationshaandboegerText", value: "reparationshåndbøger" },
  { item: "advancedSearchFilterGenreAndFormReviewsText", value: "reviews" },
  { item: "advancedSearchFilterGenreAndFormRimText", value: "rim" },
  { item: "advancedSearchFilterGenreAndFormRollespilsboegerText", value: "rollespilsbøger" },
  { item: "advancedSearchFilterGenreAndFormRomanerText", value: "romaner" },
  { item: "advancedSearchFilterGenreAndFormSagnText", value: "sagn" },
  { item: "advancedSearchFilterGenreAndFormSalmeboegerText", value: "salmebøger" },
  { item: "advancedSearchFilterGenreAndFormSalmerText", value: "salmer" },
  { item: "advancedSearchFilterGenreAndFormSamfundskritikText", value: "samfundskritik" },
  { item: "advancedSearchFilterGenreAndFormSamfundssatireText", value: "samfundssatire" },
  { item: "advancedSearchFilterGenreAndFormSamfundsskildringerText", value: "samfundsskildringer" },
  { item: "advancedSearchFilterGenreAndFormSamtalerText", value: "samtaler" },
  { item: "advancedSearchFilterGenreAndFormSangboegerText", value: "sangbøger" },
  { item: "advancedSearchFilterGenreAndFormSangeText", value: "sange" },
  { item: "advancedSearchFilterGenreAndFormSatireText", value: "satire" },
  { item: "advancedSearchFilterGenreAndFormScienceFictionText", value: "science fiction" },
  { item: "advancedSearchFilterGenreAndFormSelvhjaelpsbogText", value: "selvhjælpsbog" },
  { item: "advancedSearchFilterGenreAndFormSerieText", value: "serie" },
  { item: "advancedSearchFilterGenreAndFormSjoveBoegerText", value: "sjove bøger" },
  { item: "advancedSearchFilterGenreAndFormSkaldsoegaText", value: "skaldsøga" },
  { item: "advancedSearchFilterGenreAndFormSkuespilText", value: "skuespil" },
  { item: "advancedSearchFilterGenreAndFormSkulabokText", value: "skúlabók" },
  { item: "advancedSearchFilterGenreAndFormSlaegtsromanerText", value: "slægtsromaner" },
  { item: "advancedSearchFilterGenreAndFormSlaegtstavlerText", value: "slægtstavler" },
  { item: "advancedSearchFilterGenreAndFormSnitmoenstreText", value: "snitmønstre" },
  { item: "advancedSearchFilterGenreAndFormStandarderText", value: "standarder" },
  { item: "advancedSearchFilterGenreAndFormStatistikkerText", value: "statistikker" },
  { item: "advancedSearchFilterGenreAndFormStrikkemoenstreText", value: "strikkemønstre" },
  { item: "advancedSearchFilterGenreAndFormStuttsoegurText", value: "stuttsøgur" },
  { item: "advancedSearchFilterGenreAndFormSygehistorierText", value: "sygehistorier" },
  { item: "advancedSearchFilterGenreAndFormSoefortaellingerText", value: "søfortællinger" },
  { item: "advancedSearchFilterGenreAndFormTabelvaerkerText", value: "tabelværker" },
  { item: "advancedSearchFilterGenreAndFormTalerText", value: "taler" },
  { item: "advancedSearchFilterGenreAndFormTegneserieText", value: "tegneserie" },
  { item: "advancedSearchFilterGenreAndFormTegneserieGraphicNovelText", value: "tegneserie - graphic novel" },
  { item: "advancedSearchFilterGenreAndFormTegneserierText", value: "tegneserier" },
  { item: "advancedSearchFilterGenreAndFormTegningerText", value: "tegninger" },
  { item: "advancedSearchFilterGenreAndFormTekniskVidenskabeligRapporterText", value: "teknisk-videnskabelig rapporter" },
  { item: "advancedSearchFilterGenreAndFormThrillerText", value: "thriller" },
  { item: "advancedSearchFilterGenreAndFormTidsskriftText", value: "tidsskrift" },
  { item: "advancedSearchFilterGenreAndFormTraktaterText", value: "traktater" },
  { item: "advancedSearchFilterGenreAndFormUdstillingskatalogText", value: "udstillingskatalog" },
  { item: "advancedSearchFilterGenreAndFormUdstillingskatalogerText", value: "udstillingskataloger" },
  { item: "advancedSearchFilterGenreAndFormUdviklingsromanerText", value: "udviklingsromaner" },
  { item: "advancedSearchFilterGenreAndFormUndersoegelserText", value: "undersøgelser" },
  { item: "advancedSearchFilterGenreAndFormUndervisningsmaterialerText", value: "undervisningsmaterialer" },
  { item: "advancedSearchFilterGenreAndFormUndervisningsvejledningerText", value: "undervisningsvejledninger" },
  { item: "advancedSearchFilterGenreAndFormVegetariskeKogeboegerText", value: "vegetariske kogebøger" },
  { item: "advancedSearchFilterGenreAndFormVejledningerText", value: "vejledninger" },
  { item: "advancedSearchFilterGenreAndFormVejvisereText", value: "vejvisere" },
  { item: "advancedSearchFilterGenreAndFormVejvisereMedlemsfortegnelserText", value: "vejvisere, medlemsfortegnelser o.l." },
  { item: "advancedSearchFilterGenreAndFormWesternsText", value: "westerns" },
  { item: "advancedSearchFilterGenreAndFormYoungAdultText", value: "young adult" },
  { item: "advancedSearchFilterGenreAndFormYrkingarText", value: "yrkingar" },
  { item: "advancedSearchFilterGenreAndFormAarbogText", value: "årbog" },
  { item: "advancedSearchFilterGenreAndFormAarspublikationText", value: "årspublikation" },
  { item: "advancedSearchFilterGenreAndFormOevelserText", value: "øvelser" },
];

export const advancedSearchFilters = {
  materialTypes: "term.generalmaterialtype",
  fiction: "term.fictionnonfiction",
  accessibility: "term.accesstype",
  ageGroups: "ages",
  ages: "ages",
  publicationYear: "publicationyear",
  dk5: "dk5",
  author: "phrase.creator",
  title: "term.title",
  subject: "phrase.subject",
  lix: "lix",
  let: "let",
  primaryTarget: "phrase.primarytarget",
  source: "term.source",
  language: "phrase.mainlanguage",
  creatorcontributor: "phrase.creatorcontributor",
  childrenoradults: "term.childrenoradults",
  mood: "term.mood",
  genreandform: "term.genreandform",
  specificmaterialtype: "term.specificmaterialtype",
};
